module.exports = __webpack_public_path__ + "static/media/8.30c91192.gif";